import React, { useState, useEffect } from 'react';
import { MaterialsService } from '../services/materialsService';

function MaterialDetails({ materialId, onBack }) {
    const [material, setMaterial] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadMaterial();
    }, [materialId]);

    const loadMaterial = async () => {
        setLoading(true);
        try {
            const data = await MaterialsService.getMaterialDetails(materialId);
            setMaterial(data);
        } catch (err) {
            setError('Помилка завантаження деталей матеріалу');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading">
                <div className="loading-spinner"></div>
                <p>Завантаження...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error">
                <p>{error}</p>
                <button className="back-button" onClick={onBack}>
                    Повернутися назад
                </button>
            </div>
        );
    }

    if (!material) {
        return (
            <div className="error">
                <p>Матеріал не знайдено</p>
                <button className="back-button" onClick={onBack}>
                    Повернутися назад
                </button>
            </div>
        );
    }

    return (
        <div className="material-details">
            <button className="back-button" onClick={onBack}>
                ← Повернутися назад
            </button>

            <div className="details-header">
                <h2>{material.name}</h2>
                {material.formula && <p className="material-formula">{material.formula}</p>}
                <div className="info-row">
                    <span className="info-label">Тип:</span>
                    <span className="info-value">{material.type}</span>
                </div>
                {material.density && (
                    <div className="info-row">
                        <span className="info-label">Густина:</span>
                        <span className="info-value">{material.density} kg/m³</span>
                    </div>
                )}
                {material.description && (
                    <p style={{ marginTop: '1rem', color: '#666' }}>{material.description}</p>
                )}
            </div>

            {material.composition && material.composition.length > 0 && (
                <div className="details-section">
                    <h3>🧪 Елементний склад</h3>
                    <div className="composition-list">
                        {material.composition.map((comp, index) => (
                            <div key={index} className="composition-item">
                                <strong>{comp.symbol}</strong> - {comp.name}
                                <div style={{ 
                                    marginTop: '0.5rem',
                                    fontSize: '1.2rem',
                                    color: '#667eea'
                                }}>
                                    {comp.percentage}%
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {material.properties && material.properties.length > 0 && (
                <div className="details-section">
                    <h3>⚙️ Властивості</h3>
                    <div className="properties-list">
                        {material.properties.map((prop, index) => (
                            <div key={index} className="property-item">
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <strong>{prop.name}</strong>
                                        <div style={{ 
                                            fontSize: '0.85rem', 
                                            color: '#888',
                                            marginTop: '0.2rem'
                                        }}>
                                            {prop.category}
                                        </div>
                                    </div>
                                    <div style={{ 
                                        fontSize: '1.2rem',
                                        color: '#667eea',
                                        fontWeight: 'bold'
                                    }}>
                                        {prop.value.toLocaleString()} {prop.unit}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {material.applications && material.applications.length > 0 && (
                <div className="details-section">
                    <h3>🎯 Застосування</h3>
                    <div className="applications-list">
                        {material.applications.map((app, index) => (
                            <div key={index} className="application-item">
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '0.5rem'
                                }}>
                                    <strong>{app.name}</strong>
                                    {app.suitability && (
                                        <span className={`badge ${app.suitability.toLowerCase()}`}>
                                            {app.suitability}
                                        </span>
                                    )}
                                </div>
                                <div style={{ fontSize: '0.9rem', color: '#666' }}>
                                    <strong>Галузь:</strong> {app.industry}
                                </div>
                                {app.notes && (
                                    <div style={{ 
                                        fontSize: '0.85rem', 
                                        color: '#666',
                                        marginTop: '0.5rem',
                                        fontStyle: 'italic'
                                    }}>
                                        {app.notes}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default MaterialDetails;
